<div
	[class.items-center]="alignment() === 'center'"
	[class.mx-auto]="alignment() === 'center'"
	[class.text-center]="alignment() === 'center'"
	[class.text-left]="alignment() === 'left'"
	[editableInStoryblok]="_editable()"
	class="flex max-w-screen-md flex-col gap-4 md:gap-6"
>
	@if (topFigure()) {
		<svg-icon
			[class]="
				topFigureSize() === 'lg'
					? 'icon-container-2xl icon-container-2xl-full md:icon-container-3xl md:icon-container-3xl-full'
					: 'icon-container-xl icon-container-xl-full'
			"
			[src]="topFigure()"
			class="icon-container shrink-0 icon-container-accent"
		/>
	}
	<sb-heading-group
		[alignment]="alignment()"
		[headingType]="headingType()"
		[isSection]="true"
		[overline]="overline()"
		[size]="size()"
		[title]="title()"
	/>
	@if (content()) {
		<markdown [data]="content()" class="text-base md:text-lg" />
	}
	@if (bottomFigure()) {
		<svg-icon
			[src]="bottomFigure()"
			class="icon-container icon-container-xl icon-container-xl-full shrink-0 icon-container-accent"
		/>
	}
</div>
